import { render, staticRenderFns } from "./HodimKassaHsobot.vue?vue&type=template&id=255c706b&scoped=true"
import script from "./HodimKassaHsobot.vue?vue&type=script&lang=js"
export * from "./HodimKassaHsobot.vue?vue&type=script&lang=js"
import style0 from "./HodimKassaHsobot.vue?vue&type=style&index=0&id=255c706b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c706b",
  null
  
)

export default component.exports